import styled from 'styled-components';

export const MainText = styled.div<{ size?: number; color?: colorText | string; weight?: 'L' | 'M' }>`
    font-family: Roboto;
    font-weight: ${(props) => (props.weight === 'M' ? 400 : 300)};
    font-style: normal;
    font-size: 14px;
    line-height: 16px;
    color: ${(props) => (props.color ? props.color : colorText.main)};
`;

export enum colorText {
    main = '#2D2D2D',
    red = '#EC6464',
    header = '#626161',
    white = '#FFF'
}

export const Input = styled.input`
    border: 0.2px solid #e5e5e5;
    border-radius: 8px;
    padding: 0 8px;
    color: #626161;
`;

export const WrapperPopup = styled.div`
    font-size: 12px;
    background: #ffffff;
    fill: #fff;
    filter: drop-shadow(-4px 4px 4px rgba(174, 174, 174, 0.2)) drop-shadow(4px -4px 4px rgba(174, 174, 174, 0.2));
    border-radius: 5px;
`;
export const HeaderPopup = styled.div`
    background: #e8f3f5;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    min-height: 3em;
    display: flex;
    align-items: center;
    padding: 0 1.2em;
    z-index: 2;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
`;
export const ContentPopup = styled.div`
    height: calc(100% - 3em);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
`;

export const Rotate = styled.div<{ show: boolean }>`
    transform: ${(props) => (props.show ? '' : 'rotate(-180deg)')};
    transition: transform 150ms ease;
`;

export const Select = styled.select<{ fault?: boolean }>`
    font-family: RobotoL;
    font-style: normal;
    font-weight: 300;
    font-size: 13px;
    line-height: 15px;
    color: ${(props) => (props.fault ? 'rgba(255, 141, 141, 0.8)' : '#626161')};
    background: ${(props) => (props.fault ? '#FDE4E4' : '#FFFFFF')};
    border: 0.2px solid ${(props) => (props.fault ? 'rgba(255, 141, 141, 0.8)' : '#E5E5E5')};
    border-radius: 8px;
    width: 100%;
    transition: 0.2s linear;
`;

export const CustomTooltipContainer = styled.div`
    position: relative;
    display: inline-block;
`;

export const CustomTooltipTrigger = styled.div`
    cursor: pointer;
`;

export const CustomTooltip = styled.div<{ isVisible?: boolean }>`
    visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
    opacity: ${(props) => (props.isVisible ? 1 : 0)};
    transition:
        visibility 0.3s ease-in-out,
        opacity 0.3s ease-in-out;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    border-radius: 5px;
    padding: 10px;
    width: max-content;
    color: #333;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    fill: #fff;
    z-index: 16;
    filter: drop-shadow(-4px 4px 4px rgba(174, 174, 174, 0.2)) drop-shadow(4px -4px 4px rgba(174, 174, 174, 0.2));
`;
